import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency/model'
import { CopyButton } from '@root/shared/ui-kit/copy-button'
import { Truncate } from '@root/shared/ui-kit/truncate/truncate'

type Props = {
  currency: CurrencyModel
}

export const WalletAssetCurrencyAddress: React.FC<Props> = ({ currency }) => {
  const { t } = useTranslation()

  if (CurrencyModel.isNative(currency)) {
    return undefined
  }

  return (
    <Root>
      <Address>
        <Truncate start={4} end={5}>
          {currency.address}
        </Truncate>
      </Address>
      <Copy
        snackbarText={t('currency.token_address_copied_message', {
          ticker: currency.ticker,
        })}
        size={12}
        value={currency.address}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 1px;
  align-items: center;
`

const Address = styled(Typography).attrs({
  variant: 'body4-medium',
  component: 'div',
})`
  color: var(--text-8);
`

const Copy = styled(CopyButton)`
  color: var(--text-9);
`
